import MenuButton from 'components/header/menu-button';
import Dropdown from 'components/dropdown';
import { useState } from 'react';
import styles from './style.module.scss';

type LocaleOption = {
  id: string;
  label: string;
  isLink: boolean;
};

type LocaleSwitcherProps = {
  shouldRender: boolean;
  currentLocale: string;
  localeOptions: LocaleOption[];
  changeLocale: (code: string) => Promise<void>;
};

export function LocaleSwitcher({ 
  shouldRender,
  currentLocale,
  localeOptions,
  changeLocale,
}: LocaleSwitcherProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onToggle = () => {
    setIsOpen(prev => !prev);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <MenuButton 
      className={styles.component} 
      onClick={onToggle}
      closeMenu={onClose}
      testId="locale-switcher"
    >  
      <div>
        <div id="locale-menu">
          {currentLocale?.toUpperCase()}
        </div>
        
        {isOpen && (
          <Dropdown 
            items={localeOptions.map(option => ({
              ...option,
              onClick: async () => {
                try {
                  await changeLocale(option.id);
                  onClose();
                } catch (error) {
                  console.error('Failed to change locale:', error);
                  // Keep dropdown open on error so user can try again
                }
              },
            }))}
            className={styles.dropdown} 
          />
        )}
      </div>
    </MenuButton>
  );
}